import * as RA from 'react-admin';
import Menu from './menu';

const Layout = (props) => <RA.Layout
    {...props}
    appBar={RA.AppBar}
    menu={Menu}
/>;

export default Layout;